
import MainLayout from '@/components/layout/MainLayout';
import PersonalityAggregateChart from '@/components/dashboard/PersonalityAggregateChart';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CircleDecor } from '@/components/ui/visual-elements';

export default function CorporatePersonality() {
  return (
    <MainLayout>
      <div className="container mx-auto p-6 relative">
        <CircleDecor className="absolute top-10 right-10 opacity-10" variant="secondary" size="lg" />
        <CircleDecor className="absolute bottom-20 left-10 opacity-10" size="sm" />
        
        <h1 className="text-2xl font-bold mb-2">Dashboard de Personalidade</h1>
        <p className="text-sm text-gray-500 mb-8">Análise agregada dos traços de personalidade da sua equipe</p>
        
        <Tabs defaultValue="overview" className="space-y-6">
          <TabsList>
            <TabsTrigger value="overview">Visão Geral</TabsTrigger>
            <TabsTrigger value="departments">Por Departamento</TabsTrigger>
            <TabsTrigger value="correlations">Correlações</TabsTrigger>
          </TabsList>
          
          <TabsContent value="overview" className="space-y-6">
            <PersonalityAggregateChart />
            
            <div className="grid md:grid-cols-2 gap-6">
              <Card>
                <CardHeader>
                  <CardTitle>Distribuição de Traços</CardTitle>
                  <CardDescription>Distribuição de traços dominantes entre os colaboradores</CardDescription>
                </CardHeader>
                <CardContent className="h-64 flex items-center justify-center">
                  <p className="text-muted-foreground">Gráfico de distribuição de traços</p>
                </CardContent>
              </Card>
              
              <Card>
                <CardHeader>
                  <CardTitle>Insights</CardTitle>
                  <CardDescription>Análise dos padrões de personalidade da equipe</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="p-3 bg-blue-50 rounded-md">
                    <h4 className="font-medium">Pontos Fortes da Equipe</h4>
                    <p className="text-sm">Altos níveis de Conscienciosidade indicam uma equipe focada em resultados, meticulosa e confiável.</p>
                  </div>
                  
                  <div className="p-3 bg-green-50 rounded-md">
                    <h4 className="font-medium">Oportunidades</h4>
                    <p className="text-sm">O equilíbrio entre Extroversão e Introversão sugere uma boa mistura de colaboradores orientados para comunicação e para reflexão.</p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </TabsContent>
          
          <TabsContent value="departments">
            <Card>
              <CardHeader>
                <CardTitle>Comparativo por Departamento</CardTitle>
                <CardDescription>Análise comparativa dos traços dominantes por departamento</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="flex items-center justify-center h-64 text-muted-foreground">
                  Gráfico comparativo por departamento
                </p>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="correlations">
            <Card>
              <CardHeader>
                <CardTitle>Correlações de Personalidade e Desempenho</CardTitle>
                <CardDescription>Como os traços de personalidade se correlacionam com métricas de desempenho</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="flex items-center justify-center h-64 text-muted-foreground">
                  Gráficos de correlação
                </p>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
}
